import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

// login
import login from '@/pages/login'

// reset
import reset from '@/pages/reset'

// dashboard
import dashboard from '@/pages/dashboard'
import index from '@/pages/index'

import user from '@/pages/user'
import userDetails from '@/pages/user/details'

import report from '@/pages/report'

import anomaly from '@/pages/anomaly'

// setting
import setting from '@/pages/setting'

import about from '@/pages/about'


export default new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                title: '登陆',
            }
        },
        {
            path: '/reset',
            name: 'reset',
            component: reset,
            meta: {
                title: '重置密码',
            }
        },
        {
            path: '/',
            redirect: {name: 'index'},
            component: dashboard,
            children: [
                {
                    path: '/',
                    name: 'index',
                    component: index,
                },

                // user
                {
                    path: '/user',
                    name: 'user',
                    component: user,
                    meta: {
                        title: '用户管理',
                    }
                },
                {
                    path: '/user/details',
                    name: 'userDetails',
                    component: userDetails,
                    meta: {
                        title: '用户详情',
                    }
                },

                // report
                {
                    path: '/report',
                    name: 'report',
                    component: report,
                    meta: {
                        title: '报告中心',
                    }
                },

                {
                    path: '/anomaly',
                    name: 'anomaly',
                    component: anomaly,
                    meta: {
                        title: '异常登记表',
                    }
                },

                // setting
                {
                    path: '/setting',
                    name: 'setting',
                    component: setting,
                    meta: {
                        title: '设置',
                    }
                },
                // about
                {
                    path: '/about',
                    name: 'about',
                    component: about,
                    meta: {
                        title: '关于我们',
                    }
                },                
            ],
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js